<template>
  <div>
    <Button
      class="with-hover-text"
      :class="btnClasses"
      @click.prevent.stop="toggleMembership"
      :loading="loader"
      v-if="user"
    >
      <template v-if="localIsMember">
        <span class="text" v-if="group.type === 'default'">Membro</span>
        <span class="text" v-else-if="group.type === 'paid'">Assinado</span>
        <span class="hover-text">Sair</span>
      </template>
      <template v-else>
        Entrar
      </template>
    </Button>

    <DestroySubscriptionModal
      v-if="group.type === 'paid' && group.subscription"
      :entityName="group.name"
      :subscription="group.subscription"
      @subscription-destroyed="$emit('subscription-destroyed', group.subscription.id)"
    />
  </div>
</template>

<script>

import { mapState } from 'vuex'
import GroupsService from '@/modules/groups/services/groups-service'

import Button from '@/components/common/Button/Button'
import DestroySubscriptionModal from '@/components/subscriptions/DestroySubscriptionModal'

export default {
  name: 'GroupMembershipButton',
  props: ['group', 'color', 'isMember'],
  components: {
    Button,
    DestroySubscriptionModal
  },
  data () {
    return {
      loader: false,
      localIsMember: false
    }
  },
  created () {
    this.localIsMember = this.group.is_member
  },
  watch: {
    isMember (newStatus, oldStatus) {
      this.localIsMember = newStatus
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    btnClasses () {
      const array = [
        {
          'background-hover-color4 btn-color3 text-white': this.localIsMember,
          'btn-outline-color2': !this.localIsMember
        }
      ]
      // const color = this.color ? this.color : 'btn-outline-color2'
      // array.push(color)
      return array
    }
  },
  methods: {
    async toggleMembership () {
      if (this.group.type === 'paid' && this.group.subscription) {
        this.$bvModal.show(`destroy-subscription-${this.group.subscription.id}`)
        return false
      }

      this.loader = true
      try {
        const action = this.isMember ? 'leave' : 'join'
        await GroupsService.toggleMembership({
          groupId: this.group.id,
          action: action
        })
        this.localIsMember = !this.localIsMember
        this.$emit('group-membership-toggled', this.localIsMember)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
